/* eslint-disable react-hooks/exhaustive-deps */
import './index.css'
import { DesktopNavbar } from '../NavBar/Desktop/DesktopNavbar'
import { HomeTypeCard } from '../Card/HomeTypeCard/HomeTypeCard'
import down from '../../assets/down.svg'
import forkspoon from '../../assets/forkspoon.svg'
import pin from '../../assets/pin.svg'
import calendar from '../../assets/calendar.svg'
import user from '../../assets/user.svg'
import plus from '../../assets/plus.svg'
import minus from '../../assets/minus.svg'
import {useState, useEffect, useRef} from 'react'
import { useNavigate } from "react-router-dom";
import eventimg from '../../assets/eventimg.png'
import search from '../../assets/search.svg' 
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { MobileNavbar } from '../NavBar/Mobile/MobileNavbar'
import { CSSTransition } from 'react-transition-group';
import spinner from '../../assets/spinner.gif'
import axios from 'axios'
import { baseUrl } from '../../lib/api.js'

export const HomePage = () => {
    const history = useNavigate()
    const [listEvent, setListEvent] = useState([])
    const [guest, setGuest] = useState(1)
    const [showCategory, setShowCategory] = useState(false)
    const [category, setCategory] = useState("Pilih Kategori Makananmu")
    const [showLocation, setShowLocation] = useState(false)
    const location = ['Jakarta', 'Bandung', 'Yogyakarta']
    const [foundLocation, setFoundLocation] = useState([])
    const [shownLocation, setShownLocation] = useState(location)
    const [filterLocation, setFilterLocation] = useState('')
    const [choosenLocation, setChoosenLocation] = useState('Pilih Daerah Lokasi Kamu')
    const [showDate, setShowDate] = useState(false)
    const [selectedDate, setSelectedDate] = useState()
    const [dateShown, setDateShown] = useState('Kapan Acaranya Dilaksanakan?')
    const firstUpdate = useRef(true);
    const firstUpdate2 = useRef(true);
    const [standby, setstandby] = useState(true)
    const [loading, setLoading] = useState()
    const [showNavPopup, setShowNavPopup] = useState(false)

    const handleCloseAll = () => {
        setShowCategory(false)
        setShowDate(false)
        setShowLocation(false)
        setShowNavPopup(false)
    }

    const handleSetCategory = (e) =>{
        setCategory(e)
        setShowCategory(false)
        var elem = document.getElementById("homecat");
        elem.className = "inputquestion verytiny black";
    }

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
          } else {
            var elem = document.getElementById("HPiconcat");
            var elem2 = document.getElementById('formcategory')
            elem.style.transition = "transform 0.5s"
            if(showCategory === true){
                elem.style.transform = "rotate(180deg)"
                elem2.className="inputWrapper yellow"
            }else{
                elem.style.transform = "rotate(0deg)"
                elem2.className="inputWrapper"
            }
        }
    },[showCategory])

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
          } else {
            var elem = document.getElementById("HPiconloc");
            var elem2 = document.getElementById("formloc")
            elem.style.transition = "transform 0.5s"
            if(showLocation === true){
                elem2.className = "inputWrapper yellow"
                elem.style.transform = "rotate(180deg)"
            }else{
                elem.style.transform = "rotate(0deg)"
                elem2.className="inputWrapper"
            }
        }
    },[showLocation])

    useEffect(() => {
        if (firstUpdate.current) {
            firstUpdate.current = false;
          } else {
            var elem = document.getElementById("HPicondate");
            var elem2 = document.getElementById("formdate")
            elem.style.transition = "transform 0.5s"
            if(showDate === true){
                elem2.className = "inputWrapper yellow"
                elem.style.transform = "rotate(180deg)"
            }else{
                elem2.className = "inputWrapper"
                elem.style.transform = "rotate(0deg)"
            }
        }
    },[showDate])

    const handleSelectLocation = (e) => {
        setChoosenLocation(e)
        setShowLocation(false)
        var elem = document.getElementById("homeloc");
        elem.className = "inputquestion verytiny black";
    }

    const handleSelectDate = (e) => {
        setSelectedDate(e)
        setDateShown(`${e.getFullYear()}-${formatDate(e.getMonth()+1)}-${formatDate(e.getDate())}`)
        var elem = document.getElementById("homedate");
        elem.className = "inputquestion verytiny black";
        setShowDate(false)
    }

    const formatDate = (data) =>{
        if(data<10){
          return `0${data}`
        }else{
          return data
        }
      }

    const handleGuestChange = (e) => {
        if(e === "minus"){
            if(guest === 1){
                return
            }else{
                setGuest(guest-1)
                var elem = document.getElementById("homegue");
                elem.className = "inputquestion verytiny black";
            }
        }else{
            setGuest(guest+1)
            var elem2 = document.getElementById("homegue");
            elem2.className = "inputquestion verytiny black";   
        }
    }

    const handleSearchLocation = (e) => {
        setFilterLocation(e);
        setFoundLocation([]);
        for (var x in location){
          if (location[x].toLowerCase().includes(e.toLowerCase())){
            foundLocation.push(location[x])
          }
        }
        setShownLocation(foundLocation);
    }

    
    useEffect(() =>{
        window.scrollTo(0, 0)
        setLoading(true)
        const eventFromDB = async () => {
            try {
                const data = await callApigetEvent()
                setListEvent(data)
            } catch (error) {
                console.log("Error eventFromDB")
            }
        }
        // Turn on to use it
        eventFromDB()
        console.log(listEvent)
        // setListEvent([{id:1,cover_image:eventimg,name:"Thanksgiving",styles:"American style featuring Turkey and Sides", sisa:10, max_seat:20, date:"24 Feb", time_start:"18:00 - 20:00", venue_location:"Hotel Santika, BSD City"},
        //             {id:2,cover_image:eventimg,name:"Asian Party",styles:"Asian Style", sisa:3, max_seat:10, date:"24 Feb", time_start:"18:00 - 20:00", venue_location:"Hotel Santika, BSD City"},
        //             {id:3,cover_image:eventimg,name:"Welcome",styles:"American style featuring Turkey and Sides", sisa:10, max_seat:10, date:"24 Feb", time_start:"18:00 - 20:00", venue_location:"Hotel Santika, BSD City"},
        //             {id:4,cover_image:eventimg,name:"Thanksgiving",styles:"American style featuring Turkey and Sides", sisa:10, max_seat:20, date:"24 Feb", time_start:"18:00 - 20:00", venue_location:"Hotel Santika, BSD City"},
        //             {id:5,cover_image:eventimg,name:"Asian Party",styles:"Asian Style", sisa:3, max_seat:10, date:"24 Feb", time_start:"18:00 - 20:00", venue_location:"Hotel Santika, BSD City"},
        //             {id:6,cover_image:eventimg,name:"Welcome",styles:"American style featuring Turkey and Sides", sisa:10, max_seat:10, date:"24 Feb", time_start:"18:00 - 20:00", venue_location:"Hotel Santika, BSD City"}])
        localStorage.setItem('nav', 'home')    
    },[])

    const stylesParser = (styles) => {
        if (!styles) {
            return "N/A"
        }
        styles = styles.join(', ').replace(/, ([^,]*)$/, ' and $1')
        return styles
    }

    const parseTimeEvent = (dates) => {
        const timeStartArr = dates["time_start"].split(":")
        const timeEndArr = dates["time_end"].split(":")
        
        const parsedTimeStart = timeStartArr[0].concat(":", timeStartArr[1]);
        const parsedTimeEnd = timeEndArr[0].concat(":", timeEndArr[1]);

        const parsedTime = `${parsedTimeStart} - ${parsedTimeEnd}`
        return parsedTime
    }

    const dateEventParser = (dates) => {
        if (!dates || !dates.length) {
            return {
                "date": "N/A",
                "time_start": "N/A"
            }
        }
        const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
        ]
        dates = dates[0]

        let [_, month, date] = dates["date"]
        const idxMonth = Number(month)
        month = monthNames[idxMonth].slice(0, 3)
        date = Number(date)
        const parsedDate = `${date} ${month}`

        return {
            "date": parsedDate,
            "time_start": parseTimeEvent(dates)
        }
    }

    const parseEvent = (eventData) => {
        eventData = eventData.map((el) => {
            const { date, time_start } = dateEventParser(el.dates)
            return {
                id: el.id,
                // cover_image: el.cover_image,
                cover_image: eventimg,
                name: el.name,
                styles: stylesParser(el.styles),
                sisa: el.remaining_pax,
                max_seat: el.max_pax,
                date: date,
                time_start: time_start,
                venue_location: el.venue_location
            }
        })
        return eventData
    }

    const callApigetEvent = async (type) => {
        try {
            let params = null
            if (type) {
                params = { type }
            }
            const { data: res } = await axios({
                headers: {
                    'Content-Type': 'application/json'
                },
                method: 'get',
                url: `${baseUrl}event`,
                params
            })
            const eventData = res.data
            const parsedEvent = parseEvent(eventData)
            return parsedEvent
        } catch (error) {
            console.log("error getEventFromDB")
            // Create error handler (pop-up or something)
        }
    }

    useEffect(() => {
        if (firstUpdate2.current) {
            firstUpdate2.current = false;
        }else{
            setLoading(false)
            console.log("selesai")
            console.log(listEvent)
        }
    },[listEvent])

    const handleOpenPopUp = (e) => {
        if(e === "date"){
            setShowCategory(false)
            setShowLocation(false)
            setShowDate(true)
        }else if(e === "category"){
            setShowCategory(true)
            setShowLocation(false)
            setShowDate(false)
        }else{
            setShowCategory(false)
            setShowLocation(true)
            setShowDate(false)
        }
    }

    const handleToCategory = () => {
        setstandby(false)
        setTimeout(function() {
            history("/category");
       }, 500);
    }

    const handleToEvent = () => {
        setstandby(false)
        setTimeout(function() {
            history("/event");
       }, 500);
    }

    return (
        <div onClick={e => {e.stopPropagation();handleCloseAll()}} className='maincontainer' id="maincontainer" style={{minWidth:"100%", minHeight:"100vh", backgroundColor:"#111111", position:"relative", overflow:"unset"}}>
            <DesktopNavbar showPopup={showNavPopup} setShowPopup={setShowNavPopup}></DesktopNavbar>
            <MobileNavbar></MobileNavbar>
            {
                loading?
                <img  alt="loading" className='taplakLoading' src={spinner}></img>
                :
                <CSSTransition in={standby} timeout={{appear:2000,enter:2000,exit:500}} unmountOnExit={true} mountOnEnter={true} appear={true} classNames="main">
                <div className='testingtransisi'>
                <div className="header">
                </div>
                <div className="kontenHeader">
                    <div className="mottoKontainer">
                        <div className="mottoWrapper">
                            <p className="motto">More Than Just Dining</p>
                            <p className="miniMoto">Celebrate your special moments at home</p>
                            <button onClick={e => {handleToCategory()}} className="button1">Explore Food & Drink</button>
                        </div>
                    </div>
                    <div className="formKontainer">
                        <div className="formWrapper">
                            <div className="questionWrapper">
                                <p className="question">Type of Food</p>
                                <div id="formcategory" onClick={e => {e.preventDefault();e.stopPropagation();showCategory? setShowCategory(false):handleOpenPopUp('category')}} className="inputWrapper">
                                    <img className="iconkiri" src={forkspoon} alt="icon"></img>
                                    <p id="homecat" className="inputquestion">{category}</p>
                                    <img id="HPiconcat" className="iconkanan" src={down} alt="icon"></img>
                                    
                                </div>
                                {
                                    showCategory === true && (
                                        <div className="popupkontainer">
                                            <div style={{postion:"relative", height:"100%", width:"100%"}}>
                                                <p onClick={e => {e.preventDefault();e.stopPropagation();handleSetCategory("Chef")}} className="HPpopupfont">Chef</p>
                                                <p className="HPpopupfont" onClick={e => {e.preventDefault();e.stopPropagation();handleSetCategory("Private Dining Brands")}}>Private Dining Brands</p>
                                                <p className="HPpopupfont" onClick={e => {e.preventDefault();e.stopPropagation();handleSetCategory("Mixologist")}}>Mixologist</p>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                            <div className="questionWrapper">
                                <p className="question">Location</p>
                                <div id="formloc" onClick={e => {e.preventDefault();e.stopPropagation();showLocation? setShowLocation(false):handleOpenPopUp('location')}} className="inputWrapper">
                                    <img className="iconkiri" src={pin} alt="icon"></img>
                                    <p id="homeloc" className="inputquestion">{choosenLocation}</p>
                                    <img id="HPiconloc" className="iconkanan" src={down} alt="icon"></img>
                                </div>
                                {
                                    showLocation === true && (
                                        <div className="popupkontainer">
                                            <div style={{postion:"relative", height:"100%", width:"100%"}}>
                                                <div onClick={e => {e.preventDefault();e.stopPropagation();}} className="inputfind">
                                                    <img src={search} alt='icon' className="iconsearch"></img>
                                                    <input value={filterLocation} onChange={e => handleSearchLocation(e.target.value)} className="fieldlocation" type='text' placeholder='Search Location'/>
                                                </div>
                                                {
                                                    shownLocation.map((post) => (
                                                        <p className="HPpopupfont" onClick={e => {e.preventDefault();e.stopPropagation();handleSelectLocation(post)}}>{post}</p>
                                                    ))
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                            <div className="questionWrapper">
                                <p className="question">Date</p>
                                <div id="formdate" onClick={e => {e.preventDefault();e.stopPropagation();showDate? setShowDate(false):handleOpenPopUp('date')}} className="inputWrapper">
                                    <img className="iconkiri" src={calendar} alt="icon"></img>
                                    <p id="homedate" className="inputquestion">{dateShown}</p>
                                    <img id="HPicondate" className="iconkanan" src={down} alt="icon"></img>
                                    
                                </div>
                                {
                                    showDate === true && (
                                        <div className="popupkontainer">
                                            <div style={{postion:"relative", height:"100%", width:"100%"}}>
                                            <DatePicker
                                                id="dateStartEnd"
                                                dateFormat="MM/dd/yyyy"
                                                className={'form-control form-control-sm'}
                                                autoFocus={true}
                                                shouldCloseOnSelect={false}
                                                selected={selectedDate}
                                                onChange={(date) => handleSelectDate(date)}
                                                monthsShown={1}
                                                inline
                                                minDate={new Date()}

                                                style={{width:"100%"}}
                                            />
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                            <div className="questionWrapper">
                                <p className="question">Guest</p>
                                <div className="inputWrapper">
                                    <img className="iconkiri" src={user} alt="icon"></img>
                                    <p id="homegue" className="inputquestion">{guest} Guest</p>
                                    <img className="iconkanan" onClick={e => {e.preventDefault();e.stopPropagation();handleGuestChange("minus")}} src={minus} style={{marginRight:"15px", cursor:"pointer"}} alt="icon"></img>
                                    <img className="iconkiri" onClick={e => {e.preventDefault();e.stopPropagation();handleGuestChange("plus")}} src={plus} alt="icon" style={{cursor:"pointer"}}></img>
                                </div>
                            </div>
                            <button className="button2">Search</button>
                        </div>
                    </div>
                </div>
                <div style={{display:"flex", marginTop: "calc(400px - 30vh)",width:"90%",marginLeft:"auto",marginRight:"auto", marginBottom:"20px", alignItems:"baseline"}}>
                    <p className="eventheader">Upcoming Event</p>
                    <p onClick={e => {handleToEvent()}} className="eventsubheadline">SEE MORE EVENT</p>
                </div>
                <div className="kontainerList">
                    {listEvent.map((post) => (
                        <HomeTypeCard
                            gambar = {post.cover_image} 
                            judul = {post.name} 
                            style = {post.styles} 
                            sisa = {post.sisa} 
                            total = {post.max_seat} 
                            tanggal = {post.date} 
                            jam = {post.time_start} 
                            tempat = {post.venue_location} 
                            fungsi={()=>setstandby(false)}
                        />
                        ))}
                </div>
                </div>
            </CSSTransition>
            }
            
        </div>
        
    )
  }